import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../common/common.css";
import "./signupSuccess.css";

export default function SignupSuccess() {
  const location = useLocation();
  const state = (location && location.state) || {};
  const {
    organization = "",
    fullName = "",
    email = "",
    reference = "",
    loggedIn = false,
  } = state;

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon" aria-hidden>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="#16A34A" opacity="0.12" />
            <path
              d="M17.5 8.5L10.25 15.75L6.5 12"
              stroke="#16A34A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1 className="success-title">Your account is ready</h1>
        <p className="success-body">
          We created your organization{" "}
          <strong>{organization || "(unknown)"}</strong>
          {fullName ? (
            <>
              {" "}
              and user <strong>{fullName}</strong>
            </>
          ) : null}
          .
        </p>
        {email && (
          <p className="success-meta">
            Signed up with <strong>{email}</strong>.
          </p>
        )}
        {reference && (
          <div className="ref-chip" title="Reference number">
            Ref: {reference}
          </div>
        )}

        <div className="cta-row">
          <Link className="btn primary" to="/">
            {loggedIn ? "Open app" : "Sign in"}
          </Link>
          <Link className="btn ghost" to="/signup">
            Create another account
          </Link>
        </div>

        <div className="divider" />
        <div className="next">
          <div className="chip">Next steps</div>
          <ul className="next-list">
            <li>Invite teammates from Settings → Organization.</li>
            <li>Set access roles and permissions.</li>
            <li>Start ingesting your first documents.</li>
          </ul>
        </div>
      </div>
      <div className="success-bg" aria-hidden />
    </div>
  );
}
